import { useCallback } from 'react'

import { useGetDocumentListSettingsQuery } from '@sketch/gql-types'
// Here DocumentLayout is used in a non exhaustive way, therefore builds should
// not break after SketchQL deployments.
// eslint-disable-next-line no-restricted-imports
import { DocumentLayout } from '@sketch/gql-types/expansive'

export const useDocumentLayout = () => {
  const { data, updateQuery } = useGetDocumentListSettingsQuery()

  const updateDocumentLayout = useCallback(
    (documentsLayout: DocumentLayout) => {
      updateQuery(previous => ({
        ...previous,
        documentsLayout,
      }))
    },
    [updateQuery]
  )

  return {
    documentsLayout: data?.documentsLayout,
    updateDocumentLayout,
  }
}
